module.exports = __webpack_public_path__ + "img/yl_logo.e1f805c7.png";